<template lang="pug">
b-modal#addBoDefaultDomain(
  ref="addBoDefaultDomain"
  :title="$t('ui.combine.add_bo_default_domain')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.domain_name')").mb-1
      DebounceInput(
        size="sm"
        ref="domainName"
        required
        type="text"
        :dirty="$v.domainName.$dirty"
        :error="$v.domainName.$error"
        v-model.trim.lazy="$v.domainName.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.domainName" :name="$t('ui.domain_name')")

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      domainName: ''
    };
  },
  validations: {
    domainName: {
      required,
      isDomain: function(str) {
        var regexp = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i;

        if (regexp.test(str))
        {
          return true;
        }
        else
        {
          return false;
        }
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addBoDefaultDomainUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username,
          domain_name: this.domainName,
          domain_group: "BO_DEFAULT",
          domain_type: "DEFAULT"
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_bo_default_domain", this.feedback.status);
              }
              this.$nextTick(() => {
                this.$refs.addBoDefaultDomain.hide();
              });
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
              this.$nextTick(() => {
                this.$refs.addBoDefaultDomain.hide();
              });
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
      }
    },
    reset() {
      this.domainName = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.$refs.domainName.$el.focus();
    }
  }
};
</script>
